import React from 'react';
import { Link } from 'react-router-dom';

import { Avatar, Box, Typography } from '@mui/material';

import styled from '@emotion/styled';

import { Reservation } from '../../graphql/API';
import { getDateAndTimeInTimezoneInDayjs } from '../../utils/date';

type Props = {
  reservation: Reservation;
};

export const ReservationRequirement: React.FC<Props> = ({ reservation }) => {
  return (
    <Container>
      <Avatar
        src={reservation?.offerPicture?.thumbnail || ''}
        alt='offer-thumbnail'
        sx={{ width: '32px', height: '32px' }}
      />

      <Box display={'flex'} flexDirection={'column'} gap={'4px'}>
        <Typography fontSize={'13px'} fontFamily={'Poppins'}>
          Reservation date:{' '}
          {getDateAndTimeInTimezoneInDayjs(
            reservation?.reservationDate,
            reservation?.timeZoneId,
          )?.format('LL')}
        </Typography>
        <Typography
          component={Link}
          to={`/reservations/${reservation?.id}`}
          fontSize={'13px'}
          color={'#111'}
          fontWeight={'300'}
        >
          {reservation?.offerTitle}
        </Typography>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  padding: 8px 20px;
  border-radius: 8px;
  background-color: #f9f9f9;

  display: flex;
  align-items: center;
  gap: 12px;
`;
